import React from 'react';

/**
 * GameHomeLayout - Master layout container for game home pages
 * Provides a consistent 2/3 + 1/3 grid layout with loading states and dark mode support
 */
export function GameHomeLayout({
  children,
  sidebar,
  loading = false,
  loadingComponent = null,
  className = '',
  mainColumnClass = '',
  sidebarColumnClass = '',
  stickyHeader = null,
  footer = null,
}) {
  if (loading) {
    return loadingComponent || <GameHomeLayoutSkeleton />;
  }

  return (
    <main className={`min-h-screen bg-gray-50 dark:bg-gray-900 ${className}`}>
      {stickyHeader && (
        <div className="sticky top-0 z-40 bg-gray-50/95 dark:bg-gray-900/95 backdrop-blur-sm">
          {stickyHeader}
        </div>
      )}

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Main content area - 2/3 width on large screens */}
          <div className={`lg:col-span-2 space-y-6 ${mainColumnClass}`}>
            {children}
          </div>

          {/* Sidebar - 1/3 width on large screens */}
          {sidebar && (
            <div className={`lg:col-span-1 space-y-6 ${sidebarColumnClass}`}>
              {sidebar}
            </div>
          )}
        </div>
      </div>

      {footer}
    </main>
  );
}

/**
 * Default skeleton loader for GameHomeLayout
 */
function GameHomeLayoutSkeleton() {
  return (
    <main className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Main column skeleton */}
          <div className="lg:col-span-2 space-y-6">
            <div className="skeleton skeleton--themed h-64 rounded-2xl" />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="skeleton skeleton--themed h-40 rounded-2xl" />
              <div className="skeleton skeleton--themed h-40 rounded-2xl" />
            </div>
            <div className="skeleton skeleton--themed h-48 rounded-2xl" />
          </div>

          {/* Sidebar skeleton */}
          <div className="lg:col-span-1 space-y-6">
            <div className="skeleton skeleton--themed h-96 rounded-2xl" />
            <div className="skeleton skeleton--themed h-48 rounded-2xl" />
          </div>
        </div>
      </div>
    </main>
  );
}

export default GameHomeLayout;
